import React from "react";
import label from "../../labels/interviewProcess_en.json";

const InterviewSchedule = () => {
  return (
    <div className="dashboardContentArea">
      <h5> {label.InterviewSchedule} </h5>
      <div className="row dashboardCards"></div>
    </div>
  );
};

export default InterviewSchedule;
